<template>
  <div>
    <section :style="styles">
      <v-container fluid class="py-0">
        <v-row align="center">
          <v-col cols="2">
            <v-btn icon dark v-if="back_button" :to="back_button">
              <v-icon>fa-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="8" class="text-center">
            <h3 class="white--text" v-if="$vuetify.breakpoint.name==='xs'">{{label}}</h3>
            <h1 class="white--text" v-else>{{label}}</h1>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn
              icon
              dark
              @click="$eventBus.$emit('play_video',$store.state.website.portals_video.url)"
            >
              <v-icon>fa-question</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="add_button" justify="center" align="center">
          <v-col cols="12" class="text-center py-0">
            <v-btn
              fab
              color="secondary lighten-4"
              x-small
              @click="$eventBus.$emit('downgrade-dialog')"
              v-if="$store.getters['canDowngrade']"
            >
              <v-icon>fa-minus</v-icon>
            </v-btn>
            <v-progress-circular
              :rotate="360"
              :size="100"
              :width="15"
              :value="usage"
              color="blue darken-1"
              class="mb-0 mx-2"
            >
              <v-btn
                x-large
                fab
                dark
                color="blue"
                @click="$eventBus.$emit('upgrade-dialog')"
                v-if="$store.getters['upgrade'] && usage >=100"
              >
                <span class="caption font-weight-bold" style="font-size:0.65rem !important;">Upgrade</span>
              </v-btn>
              <v-btn
                x-large
                fab
                dark
                color="blue"
                to="/subscription"
                v-if="usage >=100 && $store.getters['isTrial']"
              >
                <span
                  class="caption font-weight-bold"
                  style="font-size:0.65rem !important;"
                >Subscribe</span>
              </v-btn>
              <v-btn
                x-large
                fab
                dark
                color="blue"
                @click="$eventBus.$emit('new-portal')"
                v-if="usage < 100"
              >
                <v-icon large>fa-plus</v-icon>
              </v-btn>
            </v-progress-circular>
            <v-btn
              fab
              color="secondary lighten-4"
              x-small
              v-if="$store.getters['canDowngrade']"
              style="opacity:0"
            >
              <v-icon>fa-minus</v-icon>
            </v-btn>

            <div class="mb-1">
              <span
                class="caption white--text"
              >{{this.$store.state.portal_count}}/{{this.$store.getters["limit"]}} Portals used</span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "MembershipBanner",
  props: {
    styles: String,
    label: { type: String, required: true },
    add_button: Boolean,
    back_button: String
  },
  computed: {
    usage() {
      return (
        (this.$store.state.portal_count / this.$store.getters["limit"]) * 100
      );
    }
  }
};
</script>

<style>
</style>